import { APIClient } from 'services/helpers/api_helper';

import * as url from 'services/helpers/url_helper';
import { GetInventoryHistoryListResponse } from 'types/APIResponsesTypes';

import {
  EditInventoryForm,
  GetInventoryHistoryListRequest,
} from 'types/product/productInventoryTypes';
import { SuccessResponse } from 'types/ResponseTypes';

const api = new APIClient();

export const getInventoryHistoryList = async (
  item_id = 0,
  page = 1,
  limit = 8,
  sort_order = 'desc'
) => {
  const req: GetInventoryHistoryListRequest = {
    item_id: item_id,
    limit: limit,
    page: page,
    sort_order: sort_order,
  };

  try {
    const response: Promise<GetInventoryHistoryListResponse> = await api.get(
      url.GET_INVENTORY_HISTORY,
      req
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdateInventory = async (
  id: string,
  FormData: EditInventoryForm
) => {
  try {
    const response: Promise<SuccessResponse> = await api.put(
      url.PUT_UPDATE_INVENTORY + id,
      {
        adjust_quantity: parseFloat(FormData.adjustQuantity),
        trans_comment: FormData.transComment,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
